import { Typography, Stack } from '@mui/material';
import type { Provider, ResourceType } from '@repo/api-gw-sdk';

import { CloudProviders } from '@/data/inventory/data';
import { ResourceTypes } from '@/data/inventory/resourceTypes';

import { CircleImage } from './shared/circleImage';

export const CloudProviderIndicator = ({
  cloudProvider,
  text,
}: {
  cloudProvider: Provider;
  text?: string;
}) => {
  return (
    <Stack direction='row' alignItems='center' gap='12px'>
      <CloudProviderCircle cloudProvider={cloudProvider} />
      <Typography>
        {text || CloudProviders[cloudProvider]?.displayName}
      </Typography>
    </Stack>
  );
};

export const CloudProviderCircle = ({
  cloudProvider,
}: {
  cloudProvider: Provider;
}) => {
  return (
    CloudProviders[cloudProvider] && (
      <CircleImage
        alt={CloudProviders[cloudProvider]?.displayName}
        src={CloudProviders[cloudProvider]?.logo}
      />
    )
  );
};

export const ResourceTypeIndicator = ({
  resourceType,
}: {
  resourceType: ResourceType;
}) => {
  const cloudProvider = ResourceTypes[resourceType]?.provider;

  return (
    <CloudProviderIndicator
      cloudProvider={cloudProvider}
      text={ResourceTypes[resourceType]?.displayName}
    />
  );
};
